/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/data-set-review.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import AuditEnumValues from 'views/pages/admin/audit-log/definitions/enums';
import { getFieldChangeItems, getProcessedFieldChangeItems } from 'views/pages/admin/audit-log/service';

const DataSetReviewRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const refactoredOldRecord = {
        ...oldRecord,
        IncludeOnlyReviewedSites: null,
        IsDeleted: null,
    };

    const refactoredNewRecord = {
        ...newRecord,
        IncludeOnlyReviewedSites: null,
        IsDeleted: null,
    };

    const enums: any = {
        ReportStatus: AuditEnumValues.ReportStatus,
    };

    const arrayOfObjects: any = {
        SiteReviews: {
            valueResolver: null as any,
        },
    };

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
            enums,
            arrayOfObjects,
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export { DataSetReviewRecordChangeGrid };
